import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Páginas
import HomePage from './pages/HomePage';
import SobreNosPage from './pages/SobreNosPage';
import ServicosPage from './pages/ServicosPage';
import ParceirosPage from './pages/ParceirosPage';
import ContatoPage from './pages/ContatoPage';

// Páginas de Soluções
import LupaParanoaPage from './pages/solucoes/LupaParanoaPage';
import LupaCastPage from './pages/solucoes/LupaCastPage';
import LIAPage from './pages/solucoes/LIAPage';
import BigDataPage from './pages/tecnologias/BigDataPage';
import DataLakehousePage from './pages/tecnologias/DataLakehousePage';
import IAPage from './pages/tecnologias/IAPage';
import MachineLearningPage from './pages/tecnologias/MachineLearningPage';

// Páginas Legais
import PoliticaPrivacidadePage from './pages/PoliticaPrivacidadePage';

// Interface para props das páginas que precisam do estado darkMode
export interface PageProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

function App() {
  // Estado para controlar o modo escuro
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      return JSON.parse(savedMode);
    }
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Função para alternar o modo escuro
  const toggleDarkMode = () => {
    setDarkMode((prevMode: boolean) => {
      const newMode = !prevMode;
      localStorage.setItem('darkMode', JSON.stringify(newMode));
      return newMode;
    });
  };

  // Efeito para aplicar a classe 'dark' ao elemento raiz
  useEffect(() => {
    const root = window.document.documentElement;
    if (darkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <Router>
      {/* Layout não envolve mais as rotas aqui */}
      <Routes>
        {/* Passa as props para cada página que usará o Layout */}
        <Route path="/" element={<HomePage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/sobre-nos" element={<SobreNosPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/servicos" element={<ServicosPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/parceiros" element={<ParceirosPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/contato" element={<ContatoPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        
        {/* Rotas de Soluções */}
        <Route path="/solucoes/lupa-paranoa" element={<LupaParanoaPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/solucoes/lupa-cast" element={<LupaCastPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/solucoes/lia" element={<LIAPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        
        {/* Rotas de Tecnologias */}
        <Route path="/tecnologias/data-lakehouse" element={<DataLakehousePage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/tecnologias/big-data" element={<BigDataPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/tecnologias/ia" element={<IAPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        <Route path="/tecnologias/machine-learning" element={<MachineLearningPage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
        
        {/* Páginas Legais */}
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidadePage darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
      </Routes>
    </Router>
  );
}

export default App;
